export default {"src":"/_next/static/media/easy.f897aafe.svg","height":61,"width":60};